module.exports = __webpack_public_path__ + "img/sunrise_0.a8b04a7d.png";